import angular from 'angular';

let ClientDetailController = function ($filter, $mdDialog, $scope, $state, City, Client, State, Toast) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  $ctrl.client;

  angular.extend($ctrl, {
    clearForm,
    handleSave,
    handleDelete,
    onChangeState,
    removeFromList
  });

  activate();

  function activate() {
    clearForm();

    loadDomainResources()
      .then(result => {
        $ctrl.states = result[0];

        loadResource($ctrl.id);
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function clearForm(form) {
    $ctrl.client = {};

    if (form) {
      form.$setPristine(); 
      form.$setUntouched();
    }
  }

  function handleDelete(client, event) {
    let confirmMessage = 'client-detail-delete-confirm-text';

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')(confirmMessage))
      .ariaLabel($filter('translate')(confirmMessage))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Client
          .destroy(client)
          .then(response => {
            Toast.success($filter('translate')('client-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('client.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:' ,  err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function handleSave(form, client) {
    if (!form.$valid) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }

    save(client);
  }

  function onChangeState(stateId) {
    $ctrl.client.city_id = undefined;
    $ctrl.loadingCities = true;

    City
      .index({
        state_id: stateId,
        limit: 10000
      })
      .then(cities => {
        $ctrl.cities = cities;
        $ctrl.loadingCities = false;
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.loadingCities = false;
      });
  }

  function removeFromList(item, list) {
    _.remove(list, {id: item.id});
  }

  // Local functions
  function loadResource(id){
    if (id) {
      $ctrl.uiState = 'LOADING';

      Client.show(id)
        .then(response => {
          if (response.mobile_user.birthdate) {
            response.mobile_user.birthdate = moment(response.mobile_user.birthdate).utc();
          }

          if (response.address_postal_code) {
            response.address_postal_code = response.address_postal_code.replace(/\-/, '');
          }
          
          if (response.city) {
            City
              .index({
                state_id: response.city.state_id,
                limit: 10000
              })
              .then(cities => {
                $ctrl.cities = cities;
                $ctrl.client = response;
                $ctrl.uiState = 'COMPLETE';
              })
              .catch(err => {
                console.log('err:' ,  err);
                $ctrl.uiState = 'ERROR';
              });
          } else {
            $ctrl.client = response;
            $ctrl.uiState = 'COMPLETE';
          }
        })
        .catch(err => {
          console.log('err:' ,  err);
          $ctrl.uiState = 'ERROR';
        });
    } else {
      $ctrl.uiState = 'COMPLETE';
    }
  }

  function loadDomainResources() {
    $ctrl.uiState = 'LOADING';
    
    let promises = [];

    promises.push(State.index());

    return Promise.all(promises);
  }

  function save(client) {
    $ctrl.saving = true;

    client.address_postal_code = client.address_postal_code.replace(/^(\d{5})(\d{3})$/, '$1-$2');

    Client
      .save(client)
      .then(response => {
        Toast.success($filter('translate')('client-detail-save-success'));
        $ctrl.client = response;
        $ctrl.saving = false;
        $state.go('client.list');
      })
      .catch(err => {
        let defaultErrMsg = 'common-server-error';
        let fourONineMsg = 'client-detail-409-error';
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error($filter('translate')(message));
        console.log('err:' ,  err);
        $ctrl.saving = false;
      });
  }
}

ClientDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'City', 'Client', 'State', 'Toast'];

export default ClientDetailController;


// WEBPACK FOOTER //
// ./client/app/components/client/client-detail.controller.js